import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const video = {

    state: {
      searchModel: null
    },

    mutations: {
        setCacheSearchModel(state, data) {
          state.searchModel = data ? {...data} : null
        },
        getPlatformGuideList(state, data) {
            data.url = API.platformGuide.getPlatformGuideList;
            CommonUtils.GetRequest(data);
        },
        addPlatformGuide(state, data) {
            data.url = API.platformGuide.addPlatformGuide;
            CommonUtils.PostRequest(data);
        },
        platformGuideShow(state, data) {
            data.url = API.platformGuide.platformGuideShow;
            CommonUtils.GetRequest(data);
        },
        salePlatformList(state, data) {
            data.url = API.platformGuide.salePlatformList;
            CommonUtils.GetRequest(data);
        },
        contentSalePlatformList(state, data) {
          data.url = API.platformGuide.contentSalePlatformList;
          CommonUtils.GetRequest(data);
        },
        platformGuideUpdate(state, data) {
            data.url = API.platformGuide.platformGuideUpdate;
            CommonUtils.PostRequest(data);
        },
        getGuideList(state, data) {
            data.url = API.platformGuide.getGuideList;
            CommonUtils.GetRequest(data);
        },
        checkGuideContent(state, data) {
            data.url = API.platformGuide.checkGuideContent;
            CommonUtils.PostRequest(data);
        },
        getGuideProductInsurance(state, data) {
          data.url = API.platformGuide.getGuideProductInsuarnce;
          CommonUtils.GetRequest(data);
        },
        getGuiApiCps(state, data) {
          data.url = API.platformGuide.getGuiApiCps;
          CommonUtils.GetRequest(data);
        }
    }



};

export default video;



// WEBPACK FOOTER //
// ./src/store/modules/platformGuide.js